import axios from 'axios';
import config from '@/config';

export function getEcoRebatesResponse(location) {
  let url = '';
  if (process.env.VUE_APP_COUNTRY === 'us' || process.env.VUE_APP_COUNTRY === 'richmond') {
    url = `${config.API_FOR_REBATE_PROGRAMS}&zip=${location}`;
  } else {
    url = `${config.API_FOR_REBATE_PROGRAMS}&canadaProvince=${location}`;
  }

  return axios.get(url).then((response) => {
    const rebatePrograms = response?.data?.EcoRebatesResponse;
    return rebatePrograms;
  }).catch(() => {
    // eslint-disable-next-line no-console
    console.log('Could not connect to server. Please wait a few minutes and retry.');
  });
}

export function getInfoByZip(zipCode) {
  return axios.get(`${config.API_FOR_STATE_BY_ZIP}/${zipCode}`)
    .then((response) => response.data)
    .catch(() => {
    // eslint-disable-next-line no-console
      console.log('Could not connect to server. Please wait a few minutes and retry.');
    });
}
